<template>
  <v-form @submit.prevent="updateItem" ref="form">
    <v-card>
      <v-card-title
        class="headline primary lighten-1 white--text justify-space-between py-1"
      >
        Create account
        <v-btn icon color="white" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-2 px-6">
        <v-overlay
          :absolute="true"
          :value="dataLoading"
          justify-center
          align-center
          opacity="0.15"
        >
          <v-progress-circular
            size="64"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>
        <v-row>
          <v-col>
            <v-text-field
              name="accountName"
              :label="attributeLabels.accountName"
              v-model="accountForm.accountName"
              type="text"
              :rules="[
                (v) => !!v || 'Required',
                (v) =>
                  (v && v.length >= 3) || 'Should contains at least 3 symbols',
                (v) =>
                  (v && v.length <= 40) || 'Should contains maximum 40 symbols',
              ]"
              validate-on-blur
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              name="userName"
              :label="attributeLabels.userName"
              v-model="accountForm.userName"
              type="text"
              :rules="[
                (v) => !!v || 'Required',
                (v) =>
                  (v && v.length >= 3) || 'Should contains at least 3 symbols',
                (v) =>
                  (v && v.length <= 40) || 'Should contains maximum 40 symbols',
              ]"
              validate-on-blur
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          name="email"
          :label="attributeLabels.email"
          v-model="accountForm.email"
          :rules="[
            (v) => !!v || 'Required',
            (v) =>
              /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(
                v
              ) || 'E-mail must be valid',
          ]"
          validate-on-blur
          type="text"
        ></v-text-field>
        <v-alert v-if="hasErrors" type="error" elevation="0" outlined>
          <div v-for="(error, key) in errors" :key="key">
            {{ prepareErrorMessage(error, key) }}
          </div>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="$emit('close')">Close</v-btn>
        <v-btn type="submit" color="primary" text> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import _ from "lodash";
import { CREATE_ACCOUNT } from "@/store/modules/account/actions";

const defaultValues = {
  accountName: null,
  userName: null,
  email: null,
};

export default {
  name: "AccountForm",
  data: function () {
    return {
      dataLoading: false,
      accountForm: _.merge({}, defaultValues),
      attributeLabels: {
        accountName: "Account name",
        userName: "User name",
        email: "Email",
      },
      errors: {},
    };
  },
  computed: {
    hasErrors: function () {
      return !_.isEmpty(this.errors);
    },
  },
  methods: {
    prepareErrorMessage(error, key) {
      return error.replace("{attribute}", key);
    },
    updateItem: function () {
      if (this.$refs.form.validate()) {
        this.dataLoading = true;
        const { accountForm } = this;
        this.$store
          .dispatch("account/" + CREATE_ACCOUNT, {
            account: accountForm,
          })
          .then(
            (response) => {
              this.dataLoading = false;
              if (response.result) {
                this.accountForm = defaultValues;
                this.$emit("submitted", response.data);
                this.errors = {};
              } else {
                this.errors = response.details;
              }
            },
            (err) => {
              console.log("Err", err);
            }
          )
          .catch(() => {});
      }
    },
  },
};
</script>
